import { getBootstrapIconUrl, BootstrapIcon } from '../Global/icons'
import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateMaskInfoStyles } from './MaskInfo.styles'
import { ATTRIBUTES, EVENTS, ACTION_TYPES, SELECTORS, type MaskInfoEventDetail } from './types/MaskInfo.type'
const Eye = getBootstrapIconUrl(BootstrapIcon.Eye)
const EyeSlash = getBootstrapIconUrl(BootstrapIcon.EyeSlash)

const t = document.createElement('template')
t.innerHTML = `
<div class="mask-info">
  <span></span> <wa-button ts-variant="inline-action" size="small" appearance="plain" pill><wa-icon src="${Eye}" aria-hidden="true"></wa-icon></wa-button>
</div>
`
const TemplateMaskInfo = t

class MaskInfo extends HTMLElement {
  private spanElement: HTMLSpanElement | null = null
  private iconElement: HTMLElement | null = null
  private buttonElement: HTMLElement | null = null
  private boundHandleClick: () => void

  constructor() {
    super()

    this.boundHandleClick = this.handleClick.bind(this)

    tryLoadDependencies(document, [WebAwesomeComponent.Icon, WebAwesomeComponent.Button])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateMaskInfoStyles().content.cloneNode(true))
    shadow.appendChild(TemplateMaskInfo.content.cloneNode(true))

    this.spanElement = shadow.querySelector(SELECTORS.SPAN)
    this.iconElement = shadow.querySelector(SELECTORS.ICON)

    this.buttonElement = shadow.querySelector(SELECTORS.BUTTON)
    if (this.buttonElement) {
      this.buttonElement.addEventListener('click', this.boundHandleClick)
    }
  }

  private handleClick() {
    const exposeValue = this.getAttribute(ATTRIBUTES.EXPOSE_VALUE)
    if (exposeValue && exposeValue.length > 0) {
      // Currently exposed, so mask it
      this.removeAttribute(ATTRIBUTES.EXPOSE_VALUE)
      this.dispatchEvent(
        new CustomEvent<MaskInfoEventDetail>(EVENTS.MASK_VALUE, {
          detail: { actionType: ACTION_TYPES.MASK_VALUE },
          bubbles: true,
          composed: true,
        }),
      )
      return
    }
    
    // Currently masked, so request to expose it
    // Dispatch event for parent components to handle (e.g., fetch from secure API)
    this.dispatchEvent(
      new CustomEvent<MaskInfoEventDetail>(EVENTS.EXPOSE_VALUE, {
        detail: { actionType: ACTION_TYPES.EXPOSE_VALUE },
        bubbles: true,
        composed: true,
      }),
    )
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('MaskInfo connectedCallback')
  }

  disconnectedCallback() {
    // Clean up event listener
    if (this.buttonElement) {
      this.buttonElement.removeEventListener('click', this.boundHandleClick)
    }
  }

  static get observedAttributes() {
    return [ATTRIBUTES.MASK_VALUE, ATTRIBUTES.EXPOSE_VALUE]
  }

  attributeChangedCallback() {
    if (!this.spanElement) return

    // Check if expose-value is set - if so, display it immediately
    const exposeValue = this.getAttribute(ATTRIBUTES.EXPOSE_VALUE)
    if (exposeValue && exposeValue.length > 0) {
      // Display the exposed value
      this.spanElement.textContent = exposeValue
      // Update icon to show EyeSlash (indicates can mask)
      if (this.iconElement) {
        this.iconElement.setAttribute('src', EyeSlash)
      }
    } else {
      // Display the masked value
      const maskValue = this.getAttribute(ATTRIBUTES.MASK_VALUE)
      this.spanElement.textContent = maskValue || ''
      // Update icon to show Eye (indicates can expose)
      if (this.iconElement) {
        this.iconElement.setAttribute('src', Eye)
      }
    }
  }
}

if (!customElements.get('ts-maskinfo')) {
  customElements.define('ts-maskinfo', MaskInfo)
}
export { MaskInfo }
